import BossModel from "@/models/BossModel";

export default class LeadChannel extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'dossier/lead-channel';

    /**
     *
     * @type {string}
     */
    static entity = 'leadChannels';

    static fields() {
		return {
			id: this.attr(null),
			name: this.attr(null),
			is_active: this.attr(null),
		}
	}

    static fetchAllForSelect() {
        return this.api()
            .limit(0)
            .get(true);
    }
}
